import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
export var push = normalize.push(function (options) {
  var url = options.url,
    _success = options.success,
    _fail = options.fail,
    _complete = options.complete;
  ks.navigateTo({
    url: url,
    success: function success() {
      _success && _success();
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, CONTAINER_NAME.KWAI);
export default push;